import { mapToBreakpoints } from '@koaly/mixins';

const getValign = (values) => {
    return mapToBreakpoints(values, (value) => {
        let rule = '';
        switch (value) {
            case 'top':
                rule = 'flex-start';
                break;
            case 'bottom':
                rule = 'flex-end';
                break;
            case 'center':
                rule = 'center';
                break;
            case 'stretch':
                rule = 'stretch';
                break;
            default:
                throw new Error(`styled-components-grid: valign must be one of "top", "bottom", "center" or "stretch". Got "${String(value)}".`);
        }
        return `align-items: ${rule};`;
    });
};

export { getValign };
//# sourceMappingURL=getValign.js.map
